import { EventWrapperProps as RBCEventWrapperProps } from "react-big-calendar";
import { WeekEvent } from "./WeekEvent";
import cn from "classnames";
import { ReactElement, ReactNode } from "react";
import { CalendarEvent } from "../../../../utils/events";

export interface EventWrapperProps extends RBCEventWrapperProps<CalendarEvent> {
  children: ReactElement<EventWrapperChildProps>;
}
interface EventWrapperChildProps {
  children: ReactElement<EventDivChildProps>;
  className: string;
  onClick: (e: React.MouseEvent<HTMLElement>) => void;
  onDoubleClick: (e: React.MouseEvent<HTMLElement>) => void;
  onKeyPress: (e: React.MouseEvent<HTMLElement>) => void;
  style?: (React.CSSProperties & { xOffset: number }) | undefined;
}
interface EventDivChildProps {
  children: ReactNode;
  className: string;
}
export function EventWrapper(props: EventWrapperProps): React.JSX.Element {
  const { event, onClick } = props;
  const className = cn(props.children.props.className, "rbc-day-slot");
  const style = props.children.props.style;

  return WeekEvent({
    onClick,
    style,
    event,
    className,
  });
}
